import {AspectRatioOrientation, PinnableAspectRatio} from './ai-prompt-box-aspect-ratio-selector.types';

const AUTO_ASPECT_RATIO_ICON = 'icon-corner';

const ASPECT_RATIO_ICONS: Record<PinnableAspectRatio, string> = {
  [PinnableAspectRatio.SQUARE]: 'icon-square',
  [PinnableAspectRatio.PORTRAIT_2_3]: 'icon-2-3-aspect-ratio',
  [PinnableAspectRatio.PORTRAIT_3_4]: 'icon-3-4-aspect-ratio',
  [PinnableAspectRatio.PORTRAIT_4_5]: 'icon-4-5-aspect-ratio',
  [PinnableAspectRatio.PORTRAIT_9_16]: 'icon-9-16-aspect-ratio',
  [PinnableAspectRatio.LANDSCAPE_3_2]: 'icon-3-2-aspect-ratio',
  [PinnableAspectRatio.LANDSCAPE_4_3]: 'icon-4-3-aspect-ratio',
  [PinnableAspectRatio.LANDSCAPE_5_4]: 'icon-5-4-aspect-ratio',
  [PinnableAspectRatio.LANDSCAPE_16_9]: 'icon-16-9-aspect-ratio',
};

/** Null for anything the selector cannot pin, which is how the Auto choice unpins. */
export const parseAspectRatio = (ratio: string | null | undefined): PinnableAspectRatio | null => {
  return Object.values(PinnableAspectRatio).find((pinnable) => pinnable === ratio) ?? null;
};

export const isAspectRatioPinned = (ratio: string | null | undefined): boolean => {
  return parseAspectRatio(ratio) !== null;
};

export const getOrientationForAspectRatio = (ratio: PinnableAspectRatio | null): AspectRatioOrientation => {
  if (!ratio) {
    return AspectRatioOrientation.LANDSCAPE;
  }

  const [width, height] = parseRatioDimensions(ratio);
  return width >= height ? AspectRatioOrientation.LANDSCAPE : AspectRatioOrientation.PORTRAIT;
};

export const getIconForAspectRatio = (ratio: PinnableAspectRatio | null): string => {
  return ratio ? ASPECT_RATIO_ICONS[ratio] : AUTO_ASPECT_RATIO_ICON;
};

const parseRatioDimensions = (ratio: PinnableAspectRatio): [width: number, height: number] => {
  const [width, height] = ratio.split(':').map(Number);
  return [width || 0, height || 0];
};
